import View from '../../View';

export interface ISettingsViewProps {
}


SettingsView.ID = "settings";
SettingsView.PATH = "/settings";

export function SettingsView ($props: ISettingsViewProps) {

    return (
        <View id={SettingsView.ID}>
            Settings View
        </View>
    );
}
